<template>
  <ConsultationPanel :initial-tab="initialTab" />
</template>

<script setup lang="ts">
import ConsultationPanel from '@/components/consultationrequest/ConsultationPanel.vue'

import { useCaseStore } from '@/stores/case'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { type ConsultationsViewTab, getInitialTab } from '@/util/consultationsTab'

const route = useRoute()
const initialTab = ref<ConsultationsViewTab>(getInitialTab(route.query.tab))

const caseStore = useCaseStore()

onMounted(caseStore.refreshCases)
</script>
